import { render, staticRenderFns } from "./modal.component.html?vue&type=template&id=d5024d5e&scoped=true&"
import script from "./modal.component.js?vue&type=script&lang=js&"
export * from "./modal.component.js?vue&type=script&lang=js&"
import style0 from "./modal.component.scss?vue&type=style&index=0&id=d5024d5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5024d5e",
  null
  
)

export default component.exports